var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 51",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4472_98204)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.3401 34.8432C31.3401 43.5005 24.3267 50.5249 15.683 50.5249C7.03922 50.5249 0 43.5264 0 34.8432C0 31.7846 0.905782 28.9334 2.40679 26.4969L18.1415 0.550781L18.6074 0.835903L4.86535 23.4901C7.68621 20.8204 11.4646 19.1615 15.6571 19.1615C24.3008 19.1615 31.3142 26.1858 31.3142 34.8432",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.0002 34.8432C64.0002 43.5005 56.9869 50.5249 48.3431 50.5249C39.6994 50.5249 32.686 43.5005 32.686 34.8432C32.686 31.7846 33.5918 28.9334 35.0928 26.4969L50.7758 0.550781L51.2416 0.835903L37.4996 23.4901C40.3205 20.8204 44.0989 19.1615 48.2914 19.1615C56.9351 19.1615 63.9485 26.1858 63.9485 34.8432",
  fill: "#231F20"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4472_98204"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 50,
  fill: "white",
  transform: "translate(0 0.550781)"
})))));
export default SvgIconQuote;